// extracted by mini-css-extract-plugin
export default {"modal":"DescriptionModal-module__v6KjK","modalContent":"DescriptionModal-module___sc1t"};